import { HeaderBar } from '@fortem-monorepo/react-spa'

import { LayoutOutlet } from '@/components/LayoutOutlet'
import { NavigationTabs, NavigationTabsList } from '@/components/NavigationTabs'
import { FLOW_LINKS } from '@/constants/links'

export interface FlowLayoutProps {}

export const FlowLayout: React.FC<FlowLayoutProps> = ({}) => {
  return (
    <>
      <HeaderBar>
        <NavigationTabs>
          <NavigationTabsList links={FLOW_LINKS} />
        </NavigationTabs>
      </HeaderBar>
      <LayoutOutlet />
    </>
  )
}
